module.exports = __webpack_public_path__ + "img/meditating.fa76ebb6.png";